import { css } from '@emotion/css';

export const dependencyOverlayStyle = css({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
  overflow: 'visible',
});

// Committed dependency edges use the primary accent color. Reads as
// a first-class visual signal — same language as the pending drag
// preview — rather than a subdued "metadata" line that competed with
// the bars for attention.
export const dependencyLineStyle = css({
  fill: 'none',
  stroke: 'var(--streamlain-v2-brand-primary)',
  strokeWidth: 1,
  pointerEvents: 'stroke',
  cursor: 'default',
  transition: 'stroke-width 0.1s ease-out',
  '&:hover': {
    strokeWidth: 2,
  },
});

export const dependencyArrowStyle = css({
  fill: 'var(--streamlain-v2-brand-primary)',
  pointerEvents: 'none',
});

// Drag-preview line while the user is drawing a new dependency.
// Solid — not dashed — so the preview reads as "real" dependency
// geometry the user is committing to, not a guide line. The stroke
// still uses the accent color to differentiate it from committed
// edges that render in the secondary text color.
export const pendingLineStyle = css({
  fill: 'none',
  stroke: 'var(--streamlain-v2-brand-primary)',
  strokeWidth: 1.5,
  pointerEvents: 'none',
});
